/*
 * Copyright (c) 2025 AirAsia Berhad (Malaysia). All rights reserved.
 *
 * This software is proprietary and confidential. Unauthorized copying of this file,
 * via any medium, is strictly prohibited. Do not distribute, copy, modify, or reuse
 * any part of this code without explicit written permission from AirAsia Move.
 *
 * For internal use only.
 */

export const LocaleCurrencyEvents = {
  tap: 'tap',
  Currency_Selected: 'Currency_Selected',
  Language_Selected: 'Language_Selected',
} as const;

export interface LocaleCurrencyAnalyticsParams {
  previousValue: string;
  selectedValue: string;
  category?: string;
  screen_name?: string;
}

export const LOCALE_CURRENCY_EVENT = 'trackEventNoEcommerce';
